<template>
  <button
    type="button"
    class="improve-writing-button"
    :class="{'disabled': isButtonDisabled, 'is-loading-or-disabled': isLoadingOrDisabled}"
    @click="onImproveWritingButtonClicked(setting.value)"
  >
    <aha-spinner
      v-if="setting.isImprovingSlide"
      size="xs"
      class="mr-1"
    />
    <span v-else class="writing-button__icon">{{ setting.icon }}</span>
    {{ $i18nPresenter.t(setting.label) }}
  </button>
</template>

<script>
export default {
  props: {
    setting: {
      type: Object,
      default: () => {},
    },
    isDefaultCanvasBlocks: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isButtonDisabled() {
      return this.setting.isDisabled || this.isDefaultCanvasBlocks
    },

    isLoadingOrDisabled() {
      if (!this.setting) return false
      return this.setting.isImprovingSlide || this.isButtonDisabled
    },
  },

  methods: {
    onImproveWritingButtonClicked(settingValue) {
      if (this.isLoadingOrDisabled) return
      this.$emit('onImproveWritingButtonClicked', settingValue)
    },
  },
}
</script>

<style lang="scss" scoped>
.improve-writing-button {
  @apply relative transform transition-all duration-100 flex;
  @apply px-3 py-2.5 text-sm space-x-2;
  @apply w-max rounded-full;
  @apply border border-base-40 text-secondary-100;
  @apply cursor-pointer hover:bg-primary-40 hover:border-primary-90 hover:text-primary-90;
  @apply focus:bg-base-0 focus:border-base-40 focus:text-secondary-100;
  &:active {
    @apply bg-primary-70 border-primary-110 text-primary-90;
  }
  &.is-loading-or-disabled {
    @apply cursor-not-allowed border border-base-40 text-secondary-100 bg-base-0;
  }
  &::v-deep {
    .aha-spinner__wrapper {
      width: 20px;
      margin-top: 1px;
    }
    .aha-spinner {
      border: 2px solid #6A1EBB;
      border-top-color: #fff;
    }
  }

  .writing-button__icon {
    @apply mr-1;
    width: 20px;
  }
}
</style>
